/* Consent-based diagnostics and select_item. Native list views, cart and purchases stay with Google & YouTube. */
(() => {
  if (window.__gapMerchandisingLoaded) return;
  const configNode = document.getElementById('gap-merchandising-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  window.__gapMerchandisingLoaded = true;
  const debug = config.debug === true;
  const seen = new Set(), observed = new WeakSet(), timers = new Map();
  let scheduled = false;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  // Use the native Google destination and consent owner; never configure it again.
  function eligibleDiagnostics(card) {
    if (!card.closest('.facet-product-grid__list')) return true;
    const query = new URLSearchParams(window.location.search);
    if ([...query.keys()].some(key => key.startsWith('filter.') || key.startsWith('filter['))) return false;
    return !query.get('sort_by') || query.get('sort_by') === 'manual';
  }
  function payload(card) {
    const grid = card.closest('.facet-product-grid__list');
    const container = grid || card.closest('[data-product-recommendations-root]') || card.parentElement;
    const cards = [...container.querySelectorAll('[data-merch-product]')];
    const context = recommendationContext(card);
    return { merch_collection: grid && config.collection ? 'collection:' + config.collection : context.id,
      merch_surface: grid ? 'collection' : context.kind,
      merch_product: card.dataset.merchProduct, merch_position: String(cards.indexOf(card) + 1), merch_arm: 'v54' };
  }
  function recommendationContext(card) {
    const root = card.closest('[data-product-recommendations-root]');
    const kind = root?.dataset.merchRowKind === 'alternatives' ? 'alternatives' : (root?.dataset.recommendationKind || 'related');
    const names = { related: 'Related products', alternatives: 'Available alternatives', complete_the_look: 'Complete the look', inline_alternative: 'Available alternative in your size' };
    return { kind, id: kind + ':' + (root?.dataset.recommendationSourceId || config.product || 'other'), name: names[kind] || 'Related products' };
  }
  function send(name, data) {
    if (!allowed() || document.hidden) return false;
    if (debug) document.dispatchEvent(new CustomEvent('gap:merch-tracked', { detail: { name, ...data } }));
    else {
      if (typeof window.gtag !== 'function') return false;
      window.gtag('event', name, { ...data, send_to: config.measurementId, transport_type: 'beacon' });
    }
    return true;
  }
  function selectItem(card, link) {
    if (config.standardSelectItem !== true) return;
    const grid = card.closest('.facet-product-grid__list');
    const related = card.closest('[data-product-recommendations-root]');
    if (!grid && !related) return;
    const container = grid || related;
    const itemId = card.dataset.merchItemId;
    const context = recommendationContext(card);
    const listId = grid ? String(config.collectionId || '') : context.id;
    const listName = grid ? config.collectionTitle : context.name;
    if (!/^shopify_ZZ_\d+_\d+$/.test(itemId || '') || !listId || !listName) return;
    const target = new URL(link.href, window.location.href);
    const declared = new URL(card.dataset.merchUrl || '', window.location.href);
    // Ignore a swatch/alternate-product link whose item ID is not this card's.
    if (target.origin !== declared.origin || target.pathname !== declared.pathname) return;
    if (target.searchParams.has('variant') && !itemId.endsWith('_' + target.searchParams.get('variant'))) return;
    const index = [...container.querySelectorAll('[data-merch-product]')].indexOf(card);
    if (index < 0) return;
    send('select_item', { item_list_id: listId, item_list_name: listName,
      items: [{ item_id: itemId, item_name: card.dataset.merchName,
        item_list_id: listId, item_list_name: listName, index }] });
  }
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      clearTimeout(timers.get(entry.target)); timers.delete(entry.target);
      if (!entry.isIntersecting || entry.intersectionRatio < 0.5 || !allowed() || document.hidden || !eligibleDiagnostics(entry.target)) continue;
      timers.set(entry.target, setTimeout(() => {
        timers.delete(entry.target);
        if (!allowed() || document.hidden || !entry.target.isConnected || !eligibleDiagnostics(entry.target)) return;
        const data = payload(entry.target), key = JSON.stringify(data);
        if (!seen.has(key) && send('gap_merch_impression', data)) seen.add(key);
      }, 1000));
    }
  }, { threshold: [0, 0.5] });
  function scan() {
    scheduled = false;
    if (!allowed()) return;
    document.querySelectorAll('#MainContent [data-merch-product]').forEach(card => {
      if (!observed.has(card)) { observed.add(card); observer.observe(card); }
    });
  }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(scan); } }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href*="/products/"]'), card = link?.closest('[data-merch-product]');
    if (card) {
      const target = new URL(link.href, window.location.href);
      const declared = new URL(card.dataset.merchUrl || '', window.location.href);
      if (target.origin !== declared.origin || target.pathname !== declared.pathname) return;
      if (eligibleDiagnostics(card)) send('gap_merch_click', payload(card));
      selectItem(card, link);
    }
  }, { capture: true });
  document.addEventListener('visitorConsentCollected', () => {
    if (!allowed()) { for (const t of timers.values()) clearTimeout(t); timers.clear(); }
    else {
      document.querySelectorAll('#MainContent [data-merch-product]').forEach(card => {
        if (observed.has(card)) { observer.unobserve(card); observer.observe(card); }
      });
      schedule();
    }
  });
  document.addEventListener('visibilitychange', () => {
    for (const timer of timers.values()) clearTimeout(timer);
    timers.clear();
    if (!document.hidden && allowed()) {
      document.querySelectorAll('#MainContent [data-merch-product]').forEach(card => {
        if (observed.has(card)) { observer.unobserve(card); observer.observe(card); }
      });
      schedule();
    }
  });
  new MutationObserver(schedule).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => { if (!error) schedule(); });
  }
  schedule();
})();


